module.exports = __webpack_public_path__ + "c3507b169d683ab6019ffe6fb4cc9ae9.pdf";